package pt.at.oss.kotlin.core.enumeration

import pt.at.oss.kotlin.core.i18n.I18nBase
import pt.at.oss.kotlin.core.i18n.PageLocale

/**
 * VatReturn regime types
 */
enum class RegimeType(override val translations: Map<PageLocale, String>) : I18nBase {
    UNION(mapOf(PageLocale.PT to "União")),
    NON_UNION(mapOf(PageLocale.PT to "Extra-União")),
    IMPORT(mapOf(PageLocale.PT to "Importação")),
    ;
}
